<!--
/card/02_card_my_info.html
-->

<template>
<div>
    <common-header title="공차카드" :showTitle="true" :showBack="true" :showHome="true" />
    <main class="benefit card card-my-info">
        <div v-if="cardData" class="container">
            <h2 class="page-title clearfix">
                MY 카드
                <!--
                <div class="f-right">
                    <button type="button" class="btn btn-sm">+ 추가</button>
                </div>
                -->
            </h2>
            <!-- 카드 정보 -->
            <div class="card-box">
                <!--210217 대표카드 표시 추가. 대표카드로 지정된 카드에는 active 클래스 추가  -->
                <!-- <div class="my-card" :class="isActive(item)"></div> -->
                <!--//210217 대표카드 표시 추가 -->
                <img :src="getCardImage(cardData.cardImg)" class="img-card" alt="공차카드">
                <!-- <img src="@/assets/img/img-card-default.png" class="img-card" alt="공차카드"> -->
                <div class="card-info clearfix">
                    <button type="button" class="btn btn-reload f-right" @click="onReload()">
                        <img src="@/assets/img/btn-pop-reload.png" alt="reload">
                    </button>
                    <p class="txt01">{{cardData.cardName}}</p>
                    <p class="txt02">{{cardData.cardBalance | toCurrency}}원</p>
                </div>
                <div class="barcode-info">
                    <img src="@/assets/img/scanner.gif" class="ico-scanner">
                    <CustomBarcode :value="cardData.cardNo" :width="1.7" />

                    <!-- <p>{{cardData.cardNo}}</p> -->
                </div>
            </div>
            <!--// 카드 정보 -->
            <!-- 버튼 영역 -->
            <div class="btn-group02 clearfix">

                <a class="btn btn-primary f-left" @click="onChareEvent()">충전하기</a>
                <a class="btn f-right" @click="onHistoryEvent()">이용조회</a>
                <a class="btn f-left" @click="onLostReport()">환불요청</a>
                <a class="btn f-right" @click="onGoCardList()">카드관리</a>
            </div>
            <!--// 버튼 영역 -->
            <h2 class="page-title">유의사항</h2>
            <ul class="ul-info01">
                <li>매장 결제 시 멤버십 스탬프 적립 또는
                    타 쿠폰 및 할인 적용이 가능합니다.(단, 중복 적용 불가)
                </li>
                <li>오더 결제 시 제휴 할인 및 기타 할인은<br>
                    적용 불가합니다.
                </li>
            </ul>
            <h2 class="page-title">이용 가능 매장</h2>
            <ul class="ul-info01">
                <li>전국 공차 매장(일부 매장 사용불가)
                </li>
                <!--210306  문구 수정 -->
                <!-- <li><a href="//goo.gl/1DecGu" target="_blank">사용 가능 매장 확인하기 (클릭)</a>
                </li> -->
                <!--//210306  문구 수정 -->
                <li>사용 불가 매장: 전국 백화점, 마트, 홈플러스,<br>
                    아울렛, 공항, 병원, 휴게소 외 일부 매장</li>
                <li>오더로 결제 시는 오더를 통해<br>
                    주문 가능 매장을 확인하시기 바랍니다.</li>
            </ul>
            <h2 class="page-title">이용 조건</h2>
            <!-- 210322 문구 수정 -->
            <ul class="ul-info01">
                <li>공차카드로 제품 결제 시 현금영수증 발급 가능합니다.</li>
                <li>스탬프 적립 및 타 쿠폰, 할인 적용 가능합니다.<br>
                    <span class="fc-gray">(단, 혜택끼리 중복 적용 불가)</span>
                </li>
                <li>오더 주문 시 총 결제 금액보다 카드 잔액 부족 시 사용 불가합니다.<br>
                    <span class="fc-gray">(단, 매장 결제 시에 한해 신용카드 및 현금 등 다른 결제수단과 함께 결제 가능)</span>
                </li>
                <li>매장에서 구매하려는 제품의 금액이 멤버십 금액권/멤버십e-Gift 금액을 초과하는 경우, 부족 금액을 다른 결제수단으로 결제 가능합니다.
                </li>
                <li>멤버십 금액권으로 공차 상품권 등 유가증권 구매는 불가합니다.
                </li>
                <li>선물받은 공차카드는 멤버십 APP에 등록된 상태에서만 사용 가능합니다.                 </li>
                <li>선물 받은 수신자 휴대폰번호로 1회까지 재전송 가능합니다.<br>
                    <span class="fc-gray">(수신자가 공차 앱에 등록 시 재전송 불가)</span>
                </li>
                <li>충전 시점으로부터 14일 이내에 금액 사용 없을 시에만 충전 취소 가능합니다.
                </li>
                <li>휴대폰 소액결제의 경우 당월에만 취소 가능하며, 익월 취소의 경우 고객센터를 통해 접수 시 별도의 환불 절차 진행해야 합니다.<br>
                    <span class="fc-gray">(익월 취소의 경우 결제 시 발생한 수수료를 제외하여 계좌로 환불 입금)</span>
                </li>
                <li>금액권 잔액 환불의 경우, 환불 카드 선택 후 [환불하기]를 통해 잔액 환불 가능합니다.
                </li>
                <li>잔액 환불은 카드 최종 충전금액의 40% 이하의 잔액이 남은 경우에만 가능합니다.<br>
                    <span class="fc-gray">(환불 금액은 계좌로 입금 처리, 충전에서 발생하는 수수료를 제외한 금액이 입금)</span>
                </li>
                <!-- 210415 문구 추가 -->
                <li>잔액 환불을 신청하시면 신청일 기준 14일 이내에 계좌로 환불 받을 수 있습니다.</li>
                <!--// 210415 문구 추가 -->
                <li>매장에서는 충전 취소 또는 환불이 불가합니다.</li>
                <li>소멸시효기간(5년) 도래 시 환불 불가합니다. </li>
            </ul>
            <!--// 210322 문구 수정 -->
        </div>
    </main>

</div>
</template>

<script>
import CustomBarcode from '@/components/common/CustomBarcode.vue';

import { CardApi } from '@/api/Api';
import { Axios } from '@/api/Axios';

export default {
    components: { CustomBarcode },
    props: ['cardNo'],
    data() {
        return {
            cardData: null
        }
    },
    created() {
        if (this.loginState != true) {
            this.$router.push('/')
            return;
        }

        this.request();
    },
    mounted() {},
    computed: {

    },
    methods: {
        onChareEvent(e) {
            this.$router.push(`/card/${this.cardNo}/charge`);
        },
        onHistoryEvent(e) {
            this.$router.push(`/card/${this.cardNo}/history`)
        },
        onLostReport(e) {
            this.$router.push(`/card/${this.cardNo}/lostReport`)
        },
        onGoCardList(e) {
            this.$router.push('/card');
        },
        onReload() {
            this.request();
        },
        request() {
            this.showLoading(true);
            Axios.get(CardApi.GET_CARD_INFO + this.cardNo, {})
                .then(res => {
                    this.showLoading(false);
                    if (res.code == '0000') {
                        this.cardData = res.data;
                    }  else {
                        this.showAlert(res.message);
                    }
                })
                .catch(err => {
                    this.showLoading(false);
                    console.log(err);
                    this.showAlert("카드 정보 조회에 실패했습니다.");
                })
        },
        getCardImage: function (cardImg) {
            return cardImg.indexOf("http") >= 0 ? cardImg : require('@/assets/img/img-card-default.png');
        },
        isActive(represent) {
            return "active";
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/card/CardDetail.vue